import {useAuth} from '@apps-common/auth-react';
import {DialogTitle} from '@apps-common/ui-components';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {useGetCollectionsCount} from '@app/api/collections';
import WelcomeDialogImage from '@app/assets/images/welcome-dialog-image';
import {
  MESSAGES_KEYS,
  getValue as getMessageSeen,
  setValue as setMessageSeen,
} from '@app/util/local-messages';

const WelcomeDialog = () => {
  const {user} = useAuth();
  const [open, setOpen] = useState(false);

  const wasShown = getMessageSeen(MESSAGES_KEYS.WELCOME_MESSAGE);

  const {data: totalCollections, isPending} = useGetCollectionsCount(
    user?.claims.organization_id,
    {
      enabled: !wasShown || !user,
    }
  );

  useEffect(() => {
    if (totalCollections === 0 && !wasShown) {
      setOpen(true);
    }
  }, [totalCollections, wasShown]);

  const onClose = () => {
    setMessageSeen(MESSAGES_KEYS.WELCOME_MESSAGE, true);
    setOpen(false);
  };

  if (wasShown || isPending) {
    return false;
  }

  return (
    <Dialog open={open} maxWidth="sm">
      <DialogTitle title="Welcome to Features Manager!" onClose={onClose} />

      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          textAlign: 'center',
        }}
      >
        <Box sx={{marginBlock: 1}}>
          <WelcomeDialogImage />
        </Box>

        <Typography variant="body1" sx={{paddingInline: 4}}>
          Upload and save your areas of interest (AOIs) or
          &ldquo;features&rdquo; to more easily reference when searching,
          delivering, and analyzing data on the Planet Insights Platform
        </Typography>
      </DialogContent>

      <DialogActions sx={{justifyContent: 'center', paddingBottom: 4}}>
        <Button variant="contained" onClick={onClose} sx={{minWidth: '240px'}}>
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WelcomeDialog;
